import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'procure-flat-gauge-chart',
  templateUrl: './flat-gauge-chart.component.html',
  styleUrl: './flat-gauge-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatGaugeChart {
  @Input({ required: true }) delimiters: number[] = [];
  @Input({ required: true }) colors: string[] = [];
  @Input({ required: true }) needlePosition: number = 0;
}
